'use strict';

import jQuery from 'jquery';
import Group from 'ol/layer/group';

const SEARCH_LEGEND_PANEL_COMPONENT_SELETOR = '[data-search-panel-legend]';

const EVENT_MAP_LAYERS_CHANGED = 'event-layer-group-changed';

const $window = jQuery(window);

export default class SearchPanelLegend {

    constructor(element) {
        const component = this;

        component.$element = jQuery(SEARCH_LEGEND_PANEL_COMPONENT_SELETOR);

        component.bindGlobalEventListeners();
    }

    bindGlobalEventListeners() {
        const component = this;

        $window.on(EVENT_MAP_LAYERS_CHANGED, (event, data) => {
            component.layers = data.layers.getLayers().getArray();

            component.renderLayers();
        });
    }

    renderLayers() {
        const component = this;

        component.$element.html('');

        component.layers.forEach((layerGroup, groupIndex) => {
            component.$element.append(`<li class="search-panel-legend__content-list-group">${layerGroup.get('title')}</li>`);

            if (layerGroup instanceof Group) {
                layerGroup.getLayers().forEach((layer, layerIndex) => {
                    let layerType = layer.get('type') == 'base' ? 'radio' : 'checkbox'
                    let layerVisible = layer.getVisible() ? 'checked' : '';

                    let visualIndicator = '';
                    let layerImage = layer.get('image');
                    let layerColor = layer.get('color');

                    if (layerImage != null) {
                        visualIndicator = `<img src="${layerImage}" class="search-panel-legend__content-list-label-color" />`;
                    } else if (layerColor != null)  {
                        visualIndicator = `<span class="search-panel-legend__content-list-label-color" style="background-color: ${layerColor}"></span>`
                    } else {
                        visualIndicator = `<span class="search-panel-legend__content-list-label-color"></span>`
                    }

                    component.$element.append(`
                        <li>
                            <input class="search-panel-legend_content-list-input sr-only" type="${layerType}" name="search-legend-layer-panel-list-input" id="layer-${groupIndex}-${layerIndex}" ${layerVisible}>
                            <label class="search-panel-legend__content-list-label" for="layer-${groupIndex}-${layerIndex}" title="${layer.get('title')}">
                                ${visualIndicator} ${layer.get('title')}
                            </label>
                        </li>
                    `);

                    jQuery(`#layer-${groupIndex}-${layerIndex}`).on('change', (event) => {
                        layer.setVisible(event.target.checked);

                        if (layer.get('type') == 'base') {
                            layerGroup.getLayers().forEach((l) => {
                                if (l != layer) {
                                    l.setVisible(false);
                                }
                            });
                        }
                    });
                });
            };
        });
    }

}

jQuery(SEARCH_LEGEND_PANEL_COMPONENT_SELETOR).each((index, element) => new SearchPanelLegend(element));
